import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';
import { Button, Select } from '../../Components/ui';
import { ROLES, ROLE_ORDER, cabinetPath } from '../config';

// Super admin ko'rish rejimi paneli (kabinet sahifasi pastida qotirilgan).
// Faqat ko'rsatish: localStorage'dagi role o'zgarmaydi.
function PreviewBar({ role }) {
  const navigate = useNavigate();
  return (
    <div className="ui-cab-preview" role="region" aria-label="Ko'rish rejimi">
      <div className="ui-cab-preview__label">
        <Eye aria-hidden="true" />
        <span>
          Ko'rish rejimi: <strong>{ROLES[role]?.name}</strong>
        </span>
      </div>
      <div className="ui-cab-preview__controls">
        <Select
          aria-label="Rolni tanlash"
          value={role}
          onChange={(event) => navigate(cabinetPath(event.target.value))}
          options={ROLE_ORDER.map((code) => ({ value: code, label: ROLES[code].name }))}
          wrapperClassName="ui-cab-preview__select"
        />
        <Button variant="secondary" leftIcon={<LogOut />} onClick={() => navigate('/')}>
          Chiqish
        </Button>
      </div>
    </div>
  );
}

export default PreviewBar;
